/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export * from "./ICoreService";
export * from "./IAppClient";
export * from "./IAppClientDependencies";
export * from "./IAppServer";
export * from "./IAppServerDependencies";
export * from "./TAppClientRegisterFunction";
export * from "./TAppServerRegisterFunction";
export * from "./TAppTranslationsRegisterFunction";
export * from "./IConstants";
